import { AvanoSearchToggleComponent } from './avano-search-toggle.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoSearchToggleComponent],
  declarations: [AvanoSearchToggleComponent]
})
export class AvanoSearchToggleModule {}
